import { createContext } from 'react';

const IconsContext = createContext({
  alarmPin: '',
  alertHeaderDesktop: '',
  alertHeaderMobile: '',
  assetIcon: '',
  assetIconRed: '',
  assetIconWhite: '',
  assetModelIcon: '',
  assetModelIconWhite: '',
  avatar: '',
  certificateIcon: '',
  chartIcon: '',
  commandControlIcon: '',
  conditionsIcon: '',
  cumminsBannerDesktop: '',
  cumminsBannerMobile: '',
  cumminsIconBlack: '',
  cumminsIconWhite: '',
  emptyStateIcon: '',
  engineIcon: '',
  errorPageIcon: '',
  eventsHeaderDesktop: '',
  eventsIcon: '',
  fleetHeaderDesktop: '',
  fleetIcon: '',
  geofencingIconBlue: '',
  geofencingIconWhite: '',
  groupPin: '',
  inventoryHeaderDesktop: '',
  inventoryHeaderMobile: '',
  loginBackgroundImage: '',
  maintenanceIconEmpty: '',
  maintenanceIconWhite: '',
  mapClusterIcon: '',
  missingImage: '',
  modbusIcon: '',
  offlinePin: '',
  onlinePin: '',
  orgIcon: '',
  orgIconWhite: '',
  partsIconBlue: '',
  partsIconGrey: '',
  primaryLinkIcon: '',
  profileIcon: '',
  provisionIcon: '',
  provisionIconWhite: '',
  pumpIcon: '',
  reminderIcon: '',
  reportingIcon: '',
  reportsHeaderDesktop: '',
  reportsHeaderMobile: '',
  searchIcon: '',
  searchIconLg: '',
  signalIcon: '',
  signalIconWhite: '',
  tigeLoginBackgroundImage: '',
  usersIcon: '',
  usersIconWhite: '',
  widgetIcon: '',
});

export const IconsProvider = IconsContext.Provider;
export const IconsConsumer = IconsContext.Consumer;
export default IconsContext;
